import './GrindingWarningsInfo.css';
import React, { JSX } from 'react';
import { BlechconOrderFile } from '../../blechcon';
import { localized, t } from '../../config/localization';

type Props = {
  readonly files: readonly BlechconOrderFile[];
};

type WarnEntry = {
  positionLabel: string;
  warnCode: string;
};

function collectWarnings(files: readonly BlechconOrderFile[]): WarnEntry[] {
  const entries: WarnEntry[] = [];
  files.forEach((file, fileIndex) => {
    file.parts.forEach((part, partIndex) => {
      if (!part.grindingWarnCode) {
        return;
      }
      const positionLabel = file.isAssembly ? `${fileIndex + 1}.${partIndex + 1}` : `${fileIndex + 1}`;
      entries.push({ positionLabel, warnCode: part.grindingWarnCode });
    });
  });
  return entries;
}

export function GrindingWarningsInfo({ files }: Props): JSX.Element | null {
  const warnings = collectWarnings(files);
  if (warnings.length === 0) {
    return null;
  }

  return (
    <div className="grinding-warnings-info" data-cy="grindingWarningsInfo">
      <div className="grinding-warnings-info__title">
        <span className="grinding-warnings-info__title-label">{localized.GRINDING_WARNINGS_TITLE_LABEL}</span>{' '}
        {localized.GRINDING_WARNINGS_TITLE}
      </div>
      <ul className="grinding-warnings-info__list">
        {warnings.map((entry, index) => (
          <li key={index} data-cy="grindingWarningsInfo__item">
            Pos. {entry.positionLabel} – {t(entry.warnCode)}
          </li>
        ))}
      </ul>
      <hr className="grinding-warnings-info__divider" />
      <div className="grinding-warnings-info__footer">
        {localized.formatString<JSX.Element>(
          localized.GRINDING_WARNINGS_FOOTER,
          <strong key="not">{localized.GRINDING_WARNINGS_FOOTER_NOT}</strong>
        )}
      </div>
      <div className="grinding-warnings-info__footer">
        {localized.formatString<JSX.Element>(
          localized.GRINDING_WARNINGS_FOOTER_DETAILS,
          <a
            key="link"
            className="grinding-warnings-info__link"
            href={localized.GRINDING_WARNINGS_MANUFACTURING_GUIDELINES_URL}
            target="_blank"
            rel="noopener noreferrer"
          >
            {localized.GRINDING_WARNINGS_MANUFACTURING_GUIDELINES_LINK}
          </a>
        )}
      </div>
    </div>
  );
}
